import { clsx } from 'clsx';
import { EntityDisplayConfigField } from '../../../interfaces/entity-display-config';
import { Tooltip } from '../../../../tooltip/Tooltip';
import styles from './EntityDisplayConfigLabel.module.scss';

export function EntityDisplayConfigLabel({
  field,
  containerClassName,
  className
}: {
  field: EntityDisplayConfigField;
  containerClassName?: string;
  className?: string;
}) {
  const id = `${field.name}-label}`;

  return (
    <div className={clsx('d-flex', containerClassName)}>
      <Tooltip dataId={id} title={field.displayName} enableOnTextOverflow>
        <span
          className={clsx(
            'text-secondary text-ellipsis',
            styles.entityDisplayConfigLabelText,
            className
          )}
          data-id={id}
        >
          {field.displayName}
        </span>
      </Tooltip>
      &nbsp;:
    </div>
  );
}
